import { Box, Typography } from "@mui/material";
import ErrorPage from "components/Common/ErrorPage";
import { SUPPORT_EMAIL } from "codes";
import history from "helpers/history";
import { sanitizeLogText } from "helpers/frontendLogger";
import { version } from "../../../package.json";

type ErrorFallbackProps = {
  error: unknown;
  componentStack: string | null;
  eventId?: string;
  resetError: () => void;
  scope: string;
};

const ErrorFallback = ({
  error,
  componentStack,
  eventId,
  resetError,
  scope,
}: ErrorFallbackProps) => {
  const normalizedError =
    error instanceof Error ? error : new Error("An unexpected error occurred");
  const environment = import.meta.env.VITE_ENV ?? "unknown";
  const timestamp = new Date().toISOString();

  return (
    <Box>
      <ErrorPage
        goBack={() => {
          resetError();
          history.back();
        }}
        push={history.push}
        address={SUPPORT_EMAIL}
      />
      {eventId && (
        <Typography color="text.secondary" textAlign="center" variant="body2">
          Support reference: {eventId}
        </Typography>
      )}
      {environment !== "main" && (
        <Box
          component="details"
          sx={{
            maxWidth: 900,
            mx: "auto",
            mt: 4,
            p: 2,
            overflowWrap: "anywhere",
          }}
        >
          <Typography component="summary" sx={{ cursor: "pointer" }}>
            Diagnostic details
          </Typography>
          <Box component="pre" sx={{ whiteSpace: "pre-wrap", mt: 2 }}>
            {sanitizeLogText(
              JSON.stringify(
                {
                  timestamp,
                  environment,
                  version,
                  scope,
                  name: normalizedError.name,
                  message: normalizedError.message,
                  stack: normalizedError.stack,
                  componentStack,
                },
                null,
                2,
              ),
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ErrorFallback;
